export default {
  noItemFound: 'موردی برای نمایش وجود ندارد',
  archived: 'بایگانی شده‎',
};
